import * as Yup from 'yup';

export default Yup.object().shape({
  phone: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD')
});
